import { apiClient } from '@services/api-client'
import { ApiError } from '@services/utils/ApiError'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { HttpStatusCode, isAxiosError } from 'axios'
import type { ApplicationDetail } from 'types/api'

export const applicationsQueryKey = ['applications']

export function useApplication(enabled = true) {
  async function getApplications() {
    try {
      const response = await apiClient.get<ApplicationDetail>(
        SNA_PREFIX + 'applications/me/'
      )
      return response.data
    } catch (error) {
      if (
        error instanceof ApiError &&
        isAxiosError(error.source) &&
        error.source.response?.status === HttpStatusCode.NotFound
      ) {
        return undefined
      }
      throw error
    }
  }

  return useQuery({
    queryKey: applicationsQueryKey,
    queryFn: getApplications,
    enabled,
    staleTime: 1000 * 60 * 5,
    retry: (failureCount, error) => {
      if (
        error instanceof ApiError &&
        isAxiosError(error.source) &&
        error.source.response?.status === HttpStatusCode.NotFound
      ) {
        return false
      }
      return failureCount < 2
    }
  })
}
